<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div
            v-show="show"
            class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm md:max-w-md sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <template v-if="visible">
                <form method="POST" @submit.prevent="section === 'payment-authorization' ? retry() : previewOrAccept()">
                    <div class="mb-4">
                        <div :class="`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-${$root.theme}-100`">
                            <svg :class="`h-8 w-8 text-${$root.theme}-600`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </div>
                        <div class="mt-4">
                            <h3 class="text-lg leading-6 font-medium text-gray-900 text-center" id="modal-headline">
                                Reschedule Payment
                            </h3>
                            <template v-if="section !== 'payment-authorization'">

                                <div v-if="payments.length === 1" class="mt-4 text-left text-center">
                                    <p class="text-gray-500 mb-1 px-4 text-center">
                                        Are you sure you want to reschedule this payment for:
                                    </p>
                                    <template v-for="payment in form.payments">
                                        <p v-if="show" class="text-center text-xl mb-4 font-semibold">{{ payment.amount | money }}</p>

                                        <input v-model="payment.payment_date"
                                            :min="today(0)"
                                            :max="lastPaymentDate(0)"
                                            type="date"
                                            name="date"
                                            id="date"
                                            :class="`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full py-3 pl-4 pr-4 sm:text-sm border-gray-300 rounded-md mb-4`"
                                            placeholder="Payment Date">

                                        <select v-model="form.payment.type"
                                            :id="`${unique}_payment_method`"
                                            name="payment_method"
                                            :class="`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 mt-1 block w-full pl-4 pr-10 py-3 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md`">
                                            <option :value="null">Choose Method:</option>
                                            <option value="same" v-if="billingProfile && billingProfile.payment_type">
                                                {{ billingProfile.payment_type === 'check' ? 'Checking' : billingProfile.cc_type }} ••••
                                                {{ billingProfile.account_last_4 }}
                                            </option>
                                            <option v-if="settings.enable_ach" value="check">Pay with Personal Bank account</option>
                                            <option value="card">Pay with Credit/Debit Card</option>
                                        </select>

                                        <pay-with-bank v-if="form.payment.type === 'check'"
                                            :first_name.sync="form.payment.first_name"
                                            :last_name.sync="form.payment.last_name"
                                            :routing_number.sync="form.payment.routing_number"
                                            :account_number.sync="form.payment.account_number"
                                            :error="error" class="mt-4" />

                                        <pay-with-card v-else-if="form.payment.type === 'card'"
                                            :first_name.sync="form.payment.first_name"
                                            :last_name.sync="form.payment.last_name"
                                            :address.sync="form.payment.address"
                                            :city.sync="form.payment.city"
                                            :state.sync="form.payment.state"
                                            :cc_number.sync="form.payment.cc_number"
                                            :card_exp.sync="form.payment.card_exp"
                                            :cvv.sync="form.payment.cvv"
                                            :zip.sync="form.payment.zip"
                                            :settings="settings"
                                            :cc-valid-status="ccValidStatus"
                                            :error="error" class="mt-4" />
                                    </template>

                                    <p class="mt-2 px-8 text-sm text-gray-600 text-center">Choose current payment or create a new one above.</p>

                                </div>
                                <div v-else class="mt-4 text-left">
                                    <p class="text-gray-500 mb-4 px-4 text-center">
                                        Are you sure you want to reschedule these payments for:
                                    </p>

                                    <select v-model="form.payment.type"
                                            :id="`${unique}_payment_method`"
                                            name="payment_method"
                                            :class="`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 mt-1 block w-full pl-4 pr-10 py-3 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md`">
                                        <option :value="null">Choose Method:</option>
                                        <option value="same" v-if="billingProfile && billingProfile.payment_type">
                                            {{ billingProfile.payment_type === 'check' ? 'Checking' : billingProfile.cc_type }} ••••
                                            {{ billingProfile.account_last_4 }}
                                        </option>
                                        <option v-if="settings.enable_ach" value="check">Pay with Personal Bank account</option>
                                        <option value="card">Pay with Credit/Debit Card</option>
                                    </select>

                                    <pay-with-bank v-if="form.payment.type === 'check'"
                                        :first_name.sync="form.payment.first_name"
                                        :last_name.sync="form.payment.last_name"
                                        :routing_number.sync="form.payment.routing_number"
                                        :account_number.sync="form.payment.account_number"
                                        :error="error" class="mt-4" />

                                    <pay-with-card v-else-if="form.payment.type === 'card'"
                                        :first_name.sync="form.payment.first_name"
                                        :last_name.sync="form.payment.last_name"
                                        :address.sync="form.payment.address"
                                        :city.sync="form.payment.city"
                                        :state.sync="form.payment.state"
                                        :cc_number.sync="form.payment.cc_number"
                                        :card_exp.sync="form.payment.card_exp"
                                        :cvv.sync="form.payment.cvv"
                                        :zip.sync="form.payment.zip"
                                        :error="error" class="mt-4"
                                        :settings="settings"
                                        :cc-valid-status="ccValidStatus" />

                                    <p class="mt-2 px-8 text-sm text-gray-600 text-center">Choose current payment or create a new one above.</p>

                                    <div class="mt-4">
                                        <template v-for="(paymentInstance, pIx) in form.payments">
                                            <div class="flex items-center" :class="{ 'mb-3': paymentInstance && paymentInstance.payment_date !== today(0) }">
                                                <div class="w-2/5 pr-2">
                                                    <p v-if="paymentInstance && show" class="text-center text-xl font-semibold">{{ paymentInstance.amount | money }}</p>
                                                </div>
                                                <div class="flex-1">
                                                    <input @change="setPaymentDate(pIx, $event.target.value)"
                                                        :value="paymentInstance && paymentInstance.payment_date"
                                                        :min="paymentInstance && previousPlusOne(pIx) || today(pIx)"
                                                        :max="paymentInstance && previousPlusSeven(pIx)"
                                                        :disabled="paymentInstance && ! paymentInstance.enabled"
                                                        type="date"
                                                        name="date"
                                                        id="date"
                                                        :class="{
                                                            [`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full py-3 pl-4 pr-4 sm:text-sm border-gray-300 rounded-md`]: true,
                                                            'cursor-not-allowed opacity-50': paymentInstance && ! paymentInstance.enabled
                                                        }"
                                                        placeholder="Payment Date">
                                                </div>

                                                <hr />
                                            </div>
                                            <div v-if="paymentInstance && paymentInstance.payment_date === today(0)" class="mb-3">
                                                <p class="mt-0.5 px-8 text-sm text-right text-gray-400 text-center">This will run now.</p>
                                            </div>
                                            <div v-else-if="paymentInstance && findPendingWithSameDate(pIx, paymentInstance.payment_date)" class="mb-3">
                                                <p class="mt-0.5 px-2 text-sm text-right text-red-400 text-center">Error: Payment already scheduled this date.</p>
                                            </div>
                                        </template>
                                    </div>

                                </div>
                            </template>
                            <div v-else
                                v-html="paymentAuthorizationAgreementTemplate"
                                class="overflow-y-auto max-h-96 p-4 my-4 border-2 border-gray-200 rounded-lg text-sm"
                            />
                        </div>
                    </div>
                    <p v-if="error" class="mb-2 text-sm text-red-600" id="email-error">Card declined.</p>
                    <div class="sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <button type="submit"
                            :class="{
                                [`w-full inline-flex text-black justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-${$root.theme}-300 text-base font-medium hover:bg-${$root.theme}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:col-start-2 sm:text-sm`]: true,
                                'cursor-not-allowed opacity-50': ! readyToSubmit
                            }"
                            :disabled="! readyToSubmit">
                            {{ section !== 'payment-authorization' ? 'Continue' : 'Reschedule Payment' }}
                        </button>
                        <button @click="section !== 'payment-authorization' ? nevermind() : previewDeclined()" type="button" :class="`mt-3 w-full inline-flex items-center justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:mt-0 sm:col-start-1 sm:text-sm`">
                            {{ section !== 'payment-authorization' ? 'Never mind' : 'Go Back' }}
                        </button>
                    </div>
                </form>
            </template>
        </div>
    </transition>
</template>

<script>
    import Moment from 'moment';
    import Mixins from '../../mixins';
    import PayWithCard from '../PaymentMethods/PayWithCard';
    import PayWithBank from '../PaymentMethods/PayWithBank';
    import PaymentAuthorization from "../../components/PaymentAuthorization.vue";
    import OfferSummary from "../OfferSummary.vue";

    export default {
        mixins: [Mixins],

        components: {
            OfferSummary,
            PaymentAuthorization,
            PayWithBank,
            PayWithCard
        },

        props: ['show', 'account', 'payments', 'pending-payments', 'billing-profile', 'settings'],

        created() {
            this.unique = Math.floor(Math.random() * 100);
        },

        /**
         * Because this entire component is created/mounted by not visible for transitions
         * most life cycle events have to have their logic tied in during
         * changes to "show"
         *
         * @returns {void}
         */
        watch: {
            show: {
                immediate: true,
                handler: function (show, oldShow) {
                    if (show && ! oldShow) {
                        if (this.payments) {
                            this.form.payment = {
                                type: ! this.settings.enable_ach && ! this.billingProfile ? 'card' : this.billingProfile ? 'same' : 'check',
                                frequency: 'monthly',
                                email: '',
                                first_name: '',
                                last_name: '',
                                address: '',
                                city: '',
                                state: '',

                                routing_number: '',
                                account_number: '',

                                cc_number: '',
                                card_exp: '',
                                exp_month: '',
                                exp_year: '',
                                cvv: '',
                                zip: ''
                            };

                            this.payments.forEach((payment, pIx) => this.form.payments.push({
                                payment_id: payment.id,
                                amount: payment.amount,
                                payment_date: this.today(pIx),
                                enabled: true,
                            }));

                            this.loadLastPossibleRescheduleDate();
                        }
                    }

                    if (! show && oldShow) {
                        this.form.payments = [];
                        this.loading = false;
                    }

                    if (! show && ! oldShow) {
                        // Mounted...
                    }
                }
            }
        },

        data() {
            return {
                section: 'reschedule',
                unique: null,
                error: null,
                loading: false,
                lastPossibleRescheduleDate: null,
                form: {
                    payment: null,
                    payments: []
                },
                paymentAuthorizationAgreementTemplate: null,
                paymentAuthorizationTransactions: null,
                forPreview: false,
            }
        },

        computed: {
            ccValidStatus() {
                if (/[^0-9-\s]+/.test(this.form.payment.cc_number)) return false;

                // The Luhn Algorithm. It's so pretty.
                var nCheck = 0,
                    nDigit = 0,
                    bEven = false;

                let value = this.form.payment.cc_number.replace(/\D/g, "");

                for (var n = value.length - 1; n >= 0; n--) {
                    var cDigit = value.charAt(n),
                        nDigit = parseInt(cDigit, 10);

                    if (bEven) {
                        if ((nDigit *= 2) > 9) nDigit -= 9;
                    }

                    nCheck += nDigit;
                    bEven = !bEven;
                }

                return (nCheck % 10) == 0;
            },

            /**
             * @returns {*}
             */
            payment() {
                if (! this.payments) return null;

                return this.payments[0];
            },

            /**
             * Checks most of the props.
             *
             * @returns {void}
             */
            visible() {
                if (! this.form.payments) return false;
                if (! this.account) return false;
                if (! this.payments) return false;
                //if (! this.billingProfile) return false;

                return true;
            },

            /**
             * @returns {String}
             */
            tomorrow() {
                return new Moment().add(1, 'days').format('YYYY-MM-DD')
            },

            /**
             * @returns {boolean}
             */
            readyToSubmit() {
                let result = true;

                this.form.payments.forEach(payment => {
                    if (! payment.payment_date) {
                        result = false;
                    }
                });

                return result;
            }
        },

        methods: {
            /**
             * @param pIx
             * @param date
             * @returns {boolean}
             */
            findPendingWithSameDate(pIx, date) {
                let sameDatePaymentIdx = this.pendingPayments.findIndex(p => p.payment_at.startsWith(date));

                if (sameDatePaymentIdx === -1) {
                    return false;
                }

                return true;
            },

            /**
             * @param paymentIdx
             * @param date
             */
            setPaymentDate(paymentIdx, date) {
                let nextPaymentIdx = paymentIdx + 1;

                this.form.payments[paymentIdx].payment_date = date;

                for (let i = nextPaymentIdx; i <= this.form.payments.length - 1; i++) {
                    // Set all following payment dates null, so they have to choose to avoid duplicates...
                    this.form.payments[i].payment_date = null;

                    if (i > (nextPaymentIdx + 1)) {
                        // Disabled all payments after the next one...
                        this.form.payments[i].enabled = false;
                    }
                }
            },

            /**
             * Get +1 days after the previous payment's date. If first index is passed
             * return false so that today's date logic can be used.
             *
             * @param paymentIndex
             * @returns {string|boolean}
             */
            previousPlusOne(paymentIndex) {
                if (paymentIndex === 0) return false;

                let previousPaymentDate = this.form.payments[paymentIndex - 1].payment_date;

                let moment = new Moment(previousPaymentDate);

                if (! moment.isValid()) {
                    moment = new Moment();
                }

                return moment.add(1, 'day').format('YYYY-MM-DD');
            },

            /**
             * Get +7 days after the previous payment's date. If first index is passed
             * return false so that today's date logic can be used.
             *
             * @param paymentIndex
             * @returns {string|boolean}
             */
            previousPlusSeven(paymentIndex) {
                if (paymentIndex === 0) return new Moment().add(7, 'day').format('YYYY-MM-DD');

                let previousPaymentDate = this.form.payments[paymentIndex - 1].payment_date;

                let moment = new Moment(previousPaymentDate);

                if (! moment.isValid()) {
                    moment = new Moment();
                }

                return moment.add(7, 'day').format('YYYY-MM-DD');
            },

            /**
             * @returns {String}
             */
            today(plusDays) {
                return new Moment().add(plusDays || 0, 'day').format('YYYY-MM-DD');
            },

            /**
             * @returns {String}
             */
            lastPaymentDate(plusDays) {
                if (this.lastPossibleRescheduleDate) {
                    return new Moment(this.lastPossibleRescheduleDate).add(plusDays, 'day').format('YYYY-MM-DD');
                }
            },

            /**
             * @returns {void}
             */
            loadLastPossibleRescheduleDate() {
                this.loading = true;

                this.$http.get(
                    `${this.$parent.consumerPortalBaseUrl}/api/payments/${this.payments[0].id}?last_possible_reschedule_date=1`
                ).then(({ data }) => {
                    this.lastPossibleRescheduleDate = data.last_possible_reschedule_date;

                    this.loading = false;
                });
            },

            previewDeclined() {
                this.section = 'reschedule';

                this.forPreview = false;

                this.$root.$refs.app.updatePageName('offers');
            },

            previewOrAccept() {
                this.forPreview = this.account.obtain_payment_authorization && this.$parent.settings.feature_payment_authorization_agreement;

                return this.retry();
            },

            /**
             * @return {void|null}
             */
            retry() {
                this.error = false;

                if (this.loading) return;

                this.loading = true;

                this.submitPayment({
                    submittedPaymentMethod: {
                        ...this.form.payment,
                        ...{
                            payments: this.form.payments
                        }
                    },
                    apiUrl: `${this.$parent.consumerPortalBaseUrl}/api/retry-payments${this.forPreview ? '/preview' : ''}`,
                    afterCallback: ({ data }) => {
                        if (this.forPreview) {
                            this.loading = false;
                            this.forPreview = false;

                            this.paymentAuthorizationAgreementTemplate = data.payment_authorization_agreement_template;
                            this.paymentAuthorizationTransactions = data.transactions;

                            this.section = 'payment-authorization';

                            this.gtagEvent('payment-authorization-requested');
                        } else {
                            if (this.account.obtain_payment_authorization && this.$parent.settings.feature_payment_authorization_agreement) {
                                this.gtagEvent('payment-authorization-accepted');
                            }

                            if (this.payments[0].status === 'declined') {
                                this.gtagEvent('offer-accepted:NSF-Reschedule');
                            } else {
                                this.gtagEvent('offer-accepted:Pending-Reschedule');
                            }

                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                    },
                    onError: error => {
                        if (error.hasOwnProperty('body')) {
                            if (error.body.hasOwnProperty('errors') && error.body.errors.hasOwnProperty('zip')) {
                                this.error = error.body.errors.zip[0];
                            } else if (error.body.hasOwnProperty('errors')) {
                                this.error = error.body.errors;
                            } else if (error.body.hasOwnProperty('error')) {
                                this.error = error.body.error;
                            }

                            this.section = 'reschedule';
                        } else {
                            throw error;
                        }

                        this.loading = false;
                    },
                    withLoading: false
                })
            },

            /**
             * @return {void}
             */
            nevermind() {
                this.$emit('close');
            },
        }
    }
</script>
